module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921122649_T.1cea7d82.jpg";